// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__3GYZv","bg":"index_bg__mhIwG","content":"index_content__CPgxu","social":"index_social__A7Fzn"};